import CategoryCard from "@components/ShopInShop/CategoryCard";

const CategoriesList = ({ categories }) => (
  <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-[10px] md:gap-[20px]">
    {categories.map((category) => (
      <li
        key={category.slug}
        className="flex flex-col border-gray-1100 bg-white border rounded-[6px] py-[30px] px-[20px] h-full"
      >
        <CategoryCard category={category} />
      </li>
    ))}
  </ul>
);

export default CategoriesList;
